import request from '@/utils/request'

let Courseware_directoryApi = {

  /*课件目录列表*/
  list(data) {
    return request._post('/shop/plus.courseware_directory.Index/index', data);
},
/*添加课件目录*/
add(data) {
    return request._post('/shop/plus.courseware_directory.Index/add', data);
},
/*修改课件目录*/
edit(data) {
    return request._post('/shop/plus.courseware_directory.Index/edit', data);
},
/*删除课件目录*/
del(data) {
    return request._post('/shop/plus.courseware_directory.Index/del', data);
},
/*课件目录详情*/
detail(data) {
  return request._post('/shop/plus.courseware_directory.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.courseware_directory.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.courseware_directory.Setting/getSetting', data, errorback);
    },
}
export default Courseware_directoryApi;



// WEBPACK FOOTER //
// ./src/api/courseware_directory.js